import Vue from 'vue'
import VueRouter from 'vue-router'
import BasicLayout from '@/layouts/BasicLayout.vue'
import OrgLayout from '@/layouts/OrgLayout.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home',
    component: BasicLayout, // 使用布局组件作为顶层视图
    children: [
      {
        path: '/home',
        name: 'Home',
        component: () => import('@/views/cme/Home')
      },
      {
        path: '/recruit',
        name: 'RecruitList',
        component: () => import('@/views/cme/RecruitList')
      },
       {
        path: '/accepted',
        name: 'Accepted',
        component: () => import('@/views/cme/Accepted')
      },
       {
        path: '/settled',
        name: 'Settled',
        component: () => import('@/views/cme/Settled')
      },
      {
        path: '/register',
        name: 'Register',
        component: () => import('@/views/cme/Register')
      },
      {
        path: '/userInfo',
        name: 'UserInfo',
        component: () => import('@/views/cme/UserInfo')
      },
       {
        path: '/changePassword',
        name: 'ChangePassword',
        component: () => import('@/views/cme/ChangePassword')
      },
       {
        path: '/changeOrg',
        name: 'ChangeOrg',
        component: () => import('@/views/cme/ChangeOrg')
      },
       {
        path: '/mySign',
        name: 'MySign',
        component: () => import('@/views/cme/MySign')
      },
       {
        path: '/system',
        name: 'System',
        component: () => import('@/views/cme/System')
      },
       {
          path: '/link',
          name: 'Link',
          component: () => import('@/views/cme/Link')
      },
       {
          path: '/privacy',
          name: 'Privacy',
          component: () => import('@/views/cme/Privacy')
      },
       {
          path: '/userPrivacy',
          name: 'UserPrivacy',
          component: () => import('@/views/cme/UserPrivacy')
      },
      {
          path: '/conduct',
          name: 'Conduct',
          component: () => import('@/views/cme/Conduct')
      },
     
     
    ]
  },
   {
          path: '/about',
          name: 'About',
          component: () => import('@/views/cme/About')
    },
     {
          path: '/contact',
          name: 'Contact',
          component: () => import('@/views/cme/Contact')
    },
     {
          path: '/jobs',
          name: 'Jobs',
          component: () => import('@/views/cme/Jobs')
    },
      {
          path: '/softWorks',
          name: 'SoftWorks',
          component: () => import('@/views/cme/SoftWorks')
    },
      {
          path: '/trademark',
          name: 'Trademark',
          component: () => import('@/views/cme/Trademark')
    },
    
     {
          path: '/agentChannel',
          name: 'AgentChannel',
          component: () => import('@/views/cme/AgentChannel')
    },
   {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/cme/Login')
  },
  {
        path: '/recover',
        name: 'Recover',
        component: () => import('@/views/cme/Recover')
  },
  
  {
    path: '/org',
    redirect: '/org/index',
    component: OrgLayout, // 使用布局组件作为顶层视图
    children: [
      {
        path: '/org/index/:orgId',
        name: 'Index',
        component: () => import('@/views/cme/orgView/Index')
      },
      {
        path: '/org/depts/:orgId',
        name: 'Depts',
        component: () => import('@/views/cme/orgView/Depts')
      },
       {
        path: '/org/depts/:orgId/:deptId',
        name: 'Depts',
        component: () => import('@/views/cme/orgView/Depts')
      },
      {
        path: '/org/expert/:orgId',
        name: 'Expert',
        component: () => import('@/views/cme/orgView/Expert')
      },
       {
        path: '/org/expert/:orgId/:id',
        name: 'Expert',
        component: () => import('@/views/cme/orgView/Expert'),
      },
      {
        path: '/org/teacherTeam/:orgId',
        name: 'TeacherTeam',
        component: () => import('@/views/cme/orgView/TeacherTeam')
      },
      {
        path: '/org/teacherTeam/:orgId/:deptId',
        name: 'TeacherTeam',
        component: () => import('@/views/cme/orgView/TeacherTeam')
      },
      {
        path: '/org/signInstruction/:orgId',
        name: 'SignInstruction',
        component: () => import('@/views/cme/orgView/SignInstruction')
      },
      {
        path: '/org/checkIn/:orgId',
        name: 'OrgCheckIn',
        component: () => import('@/views/cme/orgView/CheckIn')
      },
      {
        path: '/org/formDown/:orgId',
        name: 'FormDown',
        component: () => import('@/views/cme/orgView/FormDown')
      },
        {
        path: '/org/enrollStudent/:orgId',
        name: 'EnrollStudent',
        component: () => import('@/views/cme/orgView/EnrollStudent'),
      },
      {
        path: '/org/enrollStudent/:orgId/:cmePlanMajorId',
        name: 'EnrollStudent',
        component: () => import('@/views/cme/orgView/EnrollStudent'),
      },
       {
        path: '/org/question/:orgId',
        name: 'Question',
        component: () => import('@/views/cme/orgView/Question')
      },
       {
        path: '/org/accepted/:orgId',
        name: 'Accepted',
        component: () => import('@/views/cme/orgView/Accepted')
      },
       {
        path: '/org/accepted/:orgId/:cmePlanMajorId',
        name: 'Accepted',
        component: () => import('@/views/cme/orgView/Accepted')
      },
      {
        path: '/org/sign/:orgId',
        name: 'Sign',
        component: () => import('@/views/cme/orgView/Sign')
      },
       {
        path: '/org/sign/:orgId/:cmePlanMajorId',
        name: 'Sign',
        component: () => import('@/views/cme/orgView/Sign'),
      },
      
      
    ]
  },
   { path: '*',  component: () => import('@/views/cme/Home') }, // 404页面
]

const router = new VueRouter({
  mode: 'history',
  routes,
   scrollBehavior() {
     return { x: 0, y: 0 }
    // 始终滚动到顶部
  //  if (savedPosition) {
  //     return savedPosition
  //   } else {
  //     return { x: 0, y: 0 }
  //   }
  },
  
})

// 解决重复点击导航时，控制台出现报错
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}
export default router
